@let sub = state().subTitle;
<mat-toolbar class="header-container">
  @if (isMobile()) {
    <button mat-icon-button (click)="toggleMenu.emit()">
      <div class="flex justify-center items-center">
        <mat-icon>menu</mat-icon>
      </div>
    </button>
  }
  @if (state().company; as c) {
    <app-company-logo [companyName]="c" />
  }
  <div class="flex flex-col">
    <h3>{{ state().title }}</h3>

    <div class="text-xs text-muted font-normal">
      @if (state().withDate) {
        <span class="hidden sm:inline">{{ today | date: DATE_FORMAT }}
          @if (sub) {
            <span> · </span>
          }
        </span>

      }
      @if (sub) {
        <span>{{ sub }}</span>
      }
    </div>
  </div>

  <div class="flex-1"></div>

<!--  @if (this.state().selector) {-->
<!--    <div class="max-w-[180px] min-w-[120px] sm:min-w-[180px] ml-auto">-->
<!--      <app-select [control]="selector" [values]="menuSelector()"/>-->
<!--    </div>-->
<!--  }-->

  @if (state().status; as s) {
    <app-status [status]="s" />
  }

<!--  @if (state().showNotifications) {-->
<!--    <app-notification-bell/>-->
<!--  }-->


  @if (state().showUser) {
    <app-user-profile-menu />
  }
</mat-toolbar>
